import FeatureController from '../FeatureController';

export default class PagesController extends FeatureController
{
    constructor (panel, $state) {
        super(panel, $state);
        const self = this;
        panel.get('/v1/pages/'+$state.params.slug, (response) => {
            if (panel.okay(response)) {
               for(let i in response) {
                   self[i] = response[i];
               }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/features/pages/PagesController.js